import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute } from '@angular/router';
import { PRODUCTION_BUILD } from 'app/+app-custom/app.settings';

@Component({
    selector: 'app-dev',
    templateUrl: './dev.component.html',
    styleUrls: ['./dev.component.scss']
})
export class DevComponent implements OnInit, OnDestroy {
    
    userLoadedRemotely: boolean;

    private routeSub: Subscription;

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.routeSub = this.route.queryParams.subscribe(
            (params) => {
                const userParam = decodeURIComponent(params['user']);

                if (userParam) {
                    this.userLoadedRemotely = true;
                }
            }
        );
    }

    ngOnDestroy(): void {
        if (this.routeSub) {
            this.routeSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/components/dev/dev.component.ts